import { useQuery } from '@tanstack/react-query';

import { DATA_INIT_CACHING } from '@/configs/query';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetTerritorialAuthority = (geoAreaId?: string) => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineOrganizationApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.TERRITORIAL_AUTHORITY, geoAreaId],
    queryFn: () => api.getTerritorialAuthority({ geoAreaId }),
    enabled: isAuthenticated,
    retry: false,
    ...DATA_INIT_CACHING
  });
};
